/* Header-only glue: paints the Quotes nav badge from the same localStorage list
 * blankd-quote.js (the quote cart page) reads and writes. */
(() => {
  const KEY = "blankd:quote:v1";
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };

  function paint() {
    const count = load().length;
    document.querySelectorAll("[data-bdn-quote-count]").forEach((el) => {
      el.textContent = count || "";
      el.dataset.count = count;
    });
  }

  // Another tab (or the quote cart page itself, same tab) can change the list; storage events
  // only fire cross-tab, so also repaint on pageshow for the back-forward-cache case.
  window.addEventListener("storage", (e) => { if (e.key === KEY) paint(); });
  window.addEventListener("pageshow", paint);
  paint();
})();
